import { computed } from '@vue/composition-api';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import store from '@/renderer/store';

/**
 * @description 仅为超级管理员、管理员
 */
export const isAdminOrSuperAdmin = computed(
  () => store.getters.userRole === RoleMap.Admin || store.getters.userRole === RoleMap.SuperAdmin,
);

/**
 * @description 仅为团队管理员
 */
export const isTeamAdmin = computed(() => store.getters.userRole === RoleMap.TeamAdmin);

/**
 * @description 为超级管理员、管理员或团队管理员
 */
export const isAdmin = computed(() => isAdminOrSuperAdmin.value || isTeamAdmin.value);
